export const POPUP_AUTO_SHOW_UNTIL = `2099-12-31`;

export const isWithinPopupAutoShowPeriod = () =>
  new Date() <= new Date(`${POPUP_AUTO_SHOW_UNTIL}T23:59:59`);
